import { NavigationPathsEnum } from "@utilities/enums";
import { useNavigate } from "react-router-dom";

export const useNavigation = () => {
    const navigate = useNavigate();
    const navigateTo = (link: NavigationPathsEnum) => {
        return navigate(link);
    };
    return { navigateTo };
};
